export default __webpack_public_path__ + "static/media/Hellix-Medium.286125e3.otf";